import { render, staticRenderFns } from "./CarMonitor.vue?vue&type=template&id=2c7a645c&scoped=true&"
import script from "./CarMonitor.vue?vue&type=script&lang=js&"
export * from "./CarMonitor.vue?vue&type=script&lang=js&"
import style0 from "./CarMonitor.vue?vue&type=style&index=0&id=2c7a645c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7a645c",
  null
  
)

export default component.exports